import { render, staticRenderFns } from "./GeneralStatistic.vue?vue&type=template&id=2ba43c16"
import script from "./GeneralStatistic.vue?vue&type=script&lang=js"
export * from "./GeneralStatistic.vue?vue&type=script&lang=js"
import style0 from "./GeneralStatistic.vue?vue&type=style&index=0&id=2ba43c16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports